export const ONE_SIGNAL_APP_ID = 'portal app id';
export const GOOGLE_TAG_MANAGER_ID = 'GTM-NJ85J5P4';
